import { Input, Button } from '@material-tailwind/react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { FiSearch } from 'react-icons/fi'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { FilterPopover } from '@/shared/components/filter-popover'
import DebouncedInput from '@/shared/components/debounced-input'
import { AccreditationSelector, StatusSelector } from '@/shared/selectors'
import { CompanySizeSelector } from '@/shared/selectors/company-size-selector/company-size-selector'
import { list } from '@/router/utils'

export const CompanyFilter = ({ open, handler }) => {
  const { t } = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()

  const resetPagination = () => {
    setSearchParams(
      searchParams.set('page', '1')
    )
  }

  const searchQueryHandler = (value) => {
    if (value === '' || value === null || value === undefined) {
      searchParams.delete('q');
    } else {
      searchParams.set('q', value);
      resetPagination()
    }
    setSearchParams(searchParams)
  }

  const handleCompanySizeQuery = (selectedOption) => {
    resetPagination();
    if (selectedOption === null || selectedOption === undefined || selectedOption.value === '') {
      searchParams.delete('size');
    } else {
      searchParams.set('size', selectedOption.value);
    }
    setSearchParams(searchParams);
  };
  
  

  const handleStatusQuery = ({ value: status }) => {
    resetPagination()
    if (status === null || status === '') {
      searchParams.delete('status')
    } else {
      searchParams.set('status', status)
    }
    setSearchParams(searchParams)
  }

  const handleAccreditedQuery = ({ value: accredited }) => {
    resetPagination()
    if (accredited === null || accredited === '') {
      searchParams.delete('accredited')
    } else {
      searchParams.set('accredited', accredited)
    }
    setSearchParams(searchParams)
  }

  const removeQueries = () => {
    navigate(list('companies'));
    setSearchParams({});
    handleCompanySizeQuery(null);
    handleStatusQuery({ value: '' });
    handleAccreditedQuery({ value: '' });
  };  

  return (
    <div className='flex gap gap-3'>
      <div>
        <DebouncedInput
          icon={<FiSearch />}
          label={t('company.searcher.label')}
          onChange={searchQueryHandler}
          value={searchParams.get('q')}
          className='w-full sm:w-96'
        />
      </div>

      <FilterPopover open={open} handler={handler}>
        <div className='grid gap gap-4'>
          <div className='grid gap gap-2'>
            <CompanySizeSelector
              onChange={handleCompanySizeQuery}
              value={searchParams.get('size') || ''}
            />

            <StatusSelector
              value={searchParams.get('status') || null}
              onChange={handleStatusQuery}
            />
            <AccreditationSelector
              value={searchParams.get('accredited') || null}
              onChange={handleAccreditedQuery}
            />
          </div>
        </div>

        <div className='flex justify-center mt-10'>
          <Button
            type='button'
            className='bg-color-white text-red-600 border-solid border-2 border-red-200 p-2'
            onClick={removeQueries}
          >
            {t('filters.delete')}
          </Button>
        </div>
      </FilterPopover>
    </div>
  )
}

CompanyFilter.propTypes = {
  open: PropTypes.bool,
  handler: PropTypes.func
}
